import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import GetStarted from '@/components/GetStarted.vue';
import TheFooter from '../components/Footer.vue';
import FreePlans from '../components/FreePlans.vue';
import ProPlans from '../components/ProPlans.vue';
import SegmentAnalyticsMixin from '../helpers/vue_mixins/v2/SegmentAnalyticsMixin';
import SalesPageMixin from '../helpers/mixins/SalesPageMixin';
import ViewportSizeMixin from '../helpers/mixins/ViewportSizeMixin';
import AccordionPanel from '../components/FaqsAccordionPanel.vue';
let Pricing = class Pricing extends Mixins(SegmentAnalyticsMixin, ViewportSizeMixin, SalesPageMixin) {
    constructor() {
        super(...arguments);
        this.selectedPriceTab = 'free-plans';
    }
    get frequentlyAskedQuestions() {
        return [
            {
                question: 'What is a Messenger Mini App?',
                answer: `A Messenger Mini App is a lightweight app inside Facebook Messenger. 
                 Its purpose is to extend Facebook Messenger's functionality outside just Messaging,
                 like ordering products and book services from businesses.`,
            },
            {
                question: 'How can I start using ChatGenie?',
                answer: `You can click “Get Started Free” button that you see on our website or 
                 just go directly to https://chatgenie.ph/login/client`,
            },
            {
                question: 'What’s the difference between Free and Pro Subscription?',
                answer: `The free subscription plan has the “Powered By ChatGenie” on its 
                 Mini App and has a limited set of features as it can only export .csv 
                 files for orders once per day while Pro Subscription doesn’t have branding on 
                 its Mini App and has unlimited .csv exports per day.`,
            },
            {
                question: 'Do I need a Facebook Account to use ChatGenie as a Merchant?',
                answer: `Yes, and your Facebook account should have "Admin" role on the Facebook 
                 Page where you will connect the Mini App.`,
            },
            {
                question: 'Do I need to have a Facebook Page or Business Page to use ChatGenie?',
                answer: `Yes, a Facebook Page is required since this is where we will connect the Mini App.. 
                 Also for marketing and branding purposes, it will be easy for your customers to 
                 check if your business is legitimate if you have a Facebook Page`,
            },
            {
                question: 'How can I pay the collected convenience fees to ChatGenie?',
                answer: `Every month, all Merchants will receive their billing for the previous month. Details 
                 of the monthly billing are sent to the Mini App Admin email address(es) and can be 
                 found on the Billing Manager on ChatGenie CMS and Dashboard. Accumulated convenience 
                 fees are also shown in real-time on the widget on the upper right of the ChatGenie CMS 
                 and Dashboard pages.`,
            },
            {
                question: 'How can I remove ChatGenie Mini App from my Facebook Page?',
                answer: `To properly remove ChatGenie Mini App from your Facebook Page, you have 
                 to disconnect ChatGenie from your Facebook Page. To do this, go to the 
                 "Page Subscription" Tab under Settings Manager, then click the "Disconnect" button.`,
            },
            {
                question: 'How can I temporarily disable my Mini App?',
                answer: `The easiest way to disable your Mini App temporarily is to activate the Maintenance 
                 Mode feature. While the Maintenance Mode is activated, customers will be redirected to a 
                 Maintenance Mode Page. To activate the Maintenance Mode feature, you can go to Settings 
                 Manager then Maintenance Tab. Just turn on the Maintenance Mode switch to activate it.`,
            },
            {
                question: 'Can I upgrade/downgrade to a higher Pro plan?',
                answer: `Yes, you can upgrade anytime. If you plan to downgrade your subscription, make sure
                 that your latest billing is updated.`,
            },
            {
                question: 'How does the Plan upgrade on Free-tier Subscription work?',
                answer: `Your Free-tier Subscription plan will automatically upgrade if you reach the minimum 
                 volume requirement for higher plans.`,
            },
        ];
    }
    goToSupportPage() {
        window.open('https://support.chatgenie.ph/hc/en-us');
    }
    setSelectedTab() {
        if (this.inSalesPage) {
            this.selectedPriceTab = 'pro-plans';
        }
        else {
            this.selectedPriceTab = 'free-plans';
        }
    }
    mounted() {
        this.setSelectedTab();
        this.segmentTrack('Chatgenie Website Visit');
    }
};
Pricing = __decorate([
    Component({
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.$store.state.displayHomeNav = true;
                return true;
            });
        },
        components: {
            TheFooter,
            FreePlans,
            ProPlans,
            AccordionPanel,
            GetStarted,
        },
    })
], Pricing);
export default Pricing;
